export default "__VITE_ASSET__DOsKfb9m__"